import React from "react";

const LocationIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.951"
      height="41.056"
      viewBox="0 0 36.951 41.056"
    >
      <path
        id="db69"
        d="M235.54,227.429,226.354,230l-9.238-2.566L207.878,230l5.132-16.423,3.079-.718L226.353,226.4l10.264-13.548,3.079.718L244.829,230Zm2.1-17.962-11.291,15.4-11.291-15.4h.051a13.12,13.12,0,0,1-2.1-7.185,13.343,13.343,0,1,1,26.687,0,13.12,13.12,0,0,1-2.1,7.185ZM226.354,197.15a5.132,5.132,0,1,0,5.132,5.132A5.147,5.147,0,0,0,226.354,197.15Z"
        transform="translate(-207.878 -188.939)"
        fill={fill ? fill : "#43cfe5"}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default LocationIcon;
